import { apiClient, apiClientPaginated } from '@/lib/api-client';
import type {
  CreatePlatformUserPayload,
  PlatformUser,
  PlatformUserListParams,
  PlatformUserListResponse,
  UpdatePlatformUserPayload,
} from '@/types/platform-user';

function buildQuery(params: Record<string, string | number | boolean | undefined>): string {
  const entries = Object.entries(params).filter(([, v]) => v !== undefined && v !== '');
  if (entries.length === 0) return '';
  return `?${entries
    .map(([k, v]) => `${encodeURIComponent(k)}=${encodeURIComponent(String(v))}`)
    .join('&')}`;
}

export const platformUsersApi = {
  list: (params: PlatformUserListParams) =>
    apiClientPaginated<PlatformUserListResponse['data']>(
      `/platform/users${buildQuery({
        page: params.page,
        limit: params.limit,
        search: params.search,
        role: params.role,
        is_active: params.is_active !== undefined ? String(params.is_active) : undefined,
      })}`,
    ) as Promise<PlatformUserListResponse>,

  getById: (id: string) => apiClient<PlatformUser>(`/platform/users/${id}`),

  create: (payload: CreatePlatformUserPayload) =>
    apiClient<PlatformUser>('/platform/users', {
      method: 'POST',
      body: payload,
    }),

  update: (id: string, payload: UpdatePlatformUserPayload) =>
    apiClient<PlatformUser>(`/platform/users/${id}`, {
      method: 'PATCH',
      body: payload,
    }),

  deactivate: (id: string) =>
    apiClient<PlatformUser>(`/platform/users/${id}`, {
      method: 'DELETE',
    }),

  reactivate: (id: string) =>
    apiClient<PlatformUser>(`/platform/users/${id}/reactivate`, {
      method: 'PATCH',
    }),
};
